import { Api } from "@penn/web-common";
import { unwrap } from "@penn/web-common";
import type { FastenerBrandCode } from "./applications";

export type FastenerCatalogSource =
  | "fasteners5"
  | "sherex_product_info_with_tooling"
  | "autoriv_fasteners"
  | "profil_fasteners";

export interface FastenerCatalogItem {
  brand: FastenerBrandCode;
  typeCode: string;
  typeDisplay: string;
  source: FastenerCatalogSource;
}

export interface FastenerCatalogQuery {
  brand: FastenerBrandCode;
  q?: string;
  limit?: number;
}

export async function searchFastenerCatalog(
  query: FastenerCatalogQuery,
): Promise<FastenerCatalogItem[]> {
  const params: Record<string, string | number> = { brand: query.brand };
  if (query.q) params.q = query.q;
  if (query.limit) params.limit = query.limit;
  const res = await Api.get("/v1/catalogs/fasteners", { params });
  return unwrap<FastenerCatalogItem[]>(res.data);
}
